import React from 'react'
import { scrollTo } from '../helper/scrollTo'

const Navbar = ({ className }) => {

  let elementPostion = element => document.querySelector(element).offsetTop

  return (
    <div className={className }>
          <div className='h-100 d-flex align-items-center justify-content-between' >
             <img src="assets/passport.png" alt="logo" className='logo ms-1'/>              
             <div className=' navigation-links'>
                 <ul className='p-0 m-0 d-flex align-items-center me-4'>
                      <li
                          className='ms-2' 
                          onClick={ () => scrollTo(elementPostion('#root'))}
                       >
                        HOME 
                      </li>
                      <li 
                          className='ms-2'
                          onClick={ () => scrollTo(elementPostion('.about'))}
                      > 
                        ABOUT US
                      </li>
                      <li 
                        className='ms-2'
                        onClick={ () => scrollTo(elementPostion('.services'))}
                      > 
                         SERVICES
                    </li>
                      <li 
                         className='ms-2' 
                         onClick={ () => scrollTo(elementPostion('.projects'))}
                       > 
                          PRICE
                       </li>
                       <li 
                         className='ms-2'
                         onClick={ () => scrollTo(elementPostion('.about'))}
                       > 
                         FAQs
                      </li>
                      <li 
                         className='ms-2'
                         onClick={ () => scrollTo(elementPostion('.contact'))}
                       > 
                         CONTACT US 
                      </li>
                     
                 </ul>
             </div>             
          </div> 
    </div>
  )
}

export default Navbar